import { WindowIcon } from '@ergeon/icons/hero/outline';

import NoticePill from '@/app/components/NoticePill';

const OpenInAnotherTabNotice = () => (
  <div role="status">
    <NoticePill icon={WindowIcon}>
      {'You\'re already in this call in another tab.'}
    </NoticePill>
  </div>
);

export default OpenInAnotherTabNotice;
